"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELIVERY_STATUS_OPTIONS_ENUM = exports.DELIVERY_STATUS_ENUM = exports.DELIVERY_STATUS = void 0;
exports.DELIVERY_STATUS = [
    'ordered',
    'delivered',
    'partially_delivered',
    'pending',
    'cancelled',
    'partially_cancelled',
];
exports.DELIVERY_STATUS_ENUM = {
    ORDERED: 'ordered',
    DELIVERED: 'delivered',
    PARTIALLY_DELIVERED: 'partially_delivered',
    PENDING: 'pending',
    CANCELLED: 'cancelled',
    PARTIALLY_CANCELLED: 'partially_cancelled',
};
var DELIVERY_STATUS_OPTIONS_ENUM;
(function (DELIVERY_STATUS_OPTIONS_ENUM) {
    DELIVERY_STATUS_OPTIONS_ENUM["ORDERED"] = "ordered";
    DELIVERY_STATUS_OPTIONS_ENUM["DELIVERED"] = "delivered";
    DELIVERY_STATUS_OPTIONS_ENUM["PARTIALLY_DELIVERED"] = "partially_delivered";
    DELIVERY_STATUS_OPTIONS_ENUM["PENDING"] = "pending";
    DELIVERY_STATUS_OPTIONS_ENUM["CANCELLED"] = "cancelled";
    DELIVERY_STATUS_OPTIONS_ENUM["PARTIALLY_CANCELLED"] = "partially_cancelled";
})(DELIVERY_STATUS_OPTIONS_ENUM = exports.DELIVERY_STATUS_OPTIONS_ENUM || (exports.DELIVERY_STATUS_OPTIONS_ENUM = {}));
